const digest = 'f64fa063f41a11e4857aae9142acc3b3da6c2ee4c6d5a908687c4ece1af315e9';
const css = `._daysOfWeek_163j8_1{border-bottom:1px solid #e0e0e0}._inlineFooter_163j8_5{background-color:#fff;bottom:0;max-width:740px;position:sticky}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'daysOfWeek': '_daysOfWeek_163j8_1', 'inlineFooter': '_inlineFooter_163j8_5' };
export const daysOfWeek = '_daysOfWeek_163j8_1';
export const inlineFooter = '_inlineFooter_163j8_5';
export { css, digest };